import React from 'react'
import { useTranslations } from 'next-intl'

import { HOLIDAYS_CONTACT } from '@/src/constants/holidays'
import type { HolidayCollection } from '@/src/types/holidays'

import CollectionHero from './collectionHero'

interface CollectionHeroWrapperProps {
    breadcrumbs?: React.ReactNode
    collection: HolidayCollection
    isMobile: boolean
}

const CollectionHeroWrapper: React.FC<CollectionHeroWrapperProps> = ({ breadcrumbs, collection, isMobile }) => {
    const t = useTranslations('holidaysPage')
    const { hero, intro } = collection

    return (
        <CollectionHero
            breadcrumbs={breadcrumbs}
            heading={hero.heading}
            subheading={hero.subheading}
            banner={hero.banner}
            paragraphs={(intro?.paragraphs ?? []).filter(Boolean)}
            showMoreLabel={t('introShowMore')}
            showLessLabel={t('listShowLess')}
            phoneLabel={HOLIDAYS_CONTACT.phoneLabel}
            emailAddress={HOLIDAYS_CONTACT.email}
            emailHref={`mailto:${HOLIDAYS_CONTACT.email}`}
            isMobile={isMobile}
        />
    )
}

export { CollectionHeroWrapper }
export default CollectionHeroWrapper
